import {
  ChaseMenuItemContainer,
  ChaseMenuItemContent,
  ChaseMenuItemImage,
} from './ChaseMenuItem.styles';
import { ChaseMenuProps } from './ChaseMenuItem.types';
import Paragraph from 'components/Typography/Paragraph';

const ChaseMenuItem = ({
  imageSrc,
  title,
  active,
  ...rest
}: ChaseMenuProps): JSX.Element => {
  return (
    <ChaseMenuItemContainer active={!!active} {...rest} data-testid="menuItem">
      <ChaseMenuItemContent>
        <ChaseMenuItemImage src={imageSrc} alt={title} />
        <Paragraph>{title}</Paragraph>
      </ChaseMenuItemContent>
    </ChaseMenuItemContainer>
  );
};

export default ChaseMenuItem;
